module.exports = __webpack_public_path__ + "img/old_3.ac2bf321.jpg";